import { MeansOfPayments } from '@/features/means-of-payments/MeansOfPayments.tsx';
import { SearchPaginationContextProvider } from '@arsnovasystems/ars-front-lib';

/**
 * Wraps the means of payments view with the search and pagination context
 * required by the means of payments feature.
 *
 * @returns The means of payments page wrapped in a
 *  `SearchPaginationContextProvider`.
 */
export const MeansOfPaymentsContainer = () => {
  return (
    <SearchPaginationContextProvider>
      <MeansOfPayments />
    </SearchPaginationContextProvider>
  );
};
